var _circle, _circle2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWheel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.6513,
    cy: 21.6508,
    r: 2.44186,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.6512,
    cy: 21.6512,
    r: 19.6977,
    stroke: "currentColor",
    strokeWidth: 3.90698
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.4884,
    y: 2.11621,
    width: 0.325581,
    height: 39.0698,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41.1862,
    y: 21.4883,
    width: 0.325581,
    height: 39.0698,
    transform: "rotate(90 41.1862 21.4883)",
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35.3257,
    y: 7.65137,
    width: 0.325581,
    height: 39.0698,
    transform: "rotate(45 35.3257 7.65137)",
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35.4884,
    y: 35.3262,
    width: 0.325581,
    height: 39.0698,
    transform: "rotate(135 35.4884 35.3262)",
    fill: "currentColor"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 31.256,
    y: 4.7207,
    width: 0.325581,
    height: 39.0698,
    transform: "rotate(30 31.256 4.7207)",
    fill: "currentColor"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 38.7441,
    y: 31.2559,
    width: 0.325581,
    height: 39.0698,
    transform: "rotate(120 38.7441 31.2559)",
    fill: "currentColor"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5349,
    y: 16.4424,
    width: 0.325581,
    height: 39.0698,
    transform: "rotate(75 40.5349 16.4424)",
    fill: "currentColor"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 26.8605,
    y: 40.5352,
    width: 0.325581,
    height: 39.0698,
    transform: "rotate(165 26.8605 40.5352)",
    fill: "currentColor"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5349,
    y: 2.76758,
    width: 0.325581,
    height: 39.0698,
    transform: "rotate(15 26.5349 2.76758)",
    fill: "currentColor"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5349,
    y: 26.5352,
    width: 0.325581,
    height: 39.0698,
    transform: "rotate(105 40.5349 26.5352)",
    fill: "currentColor"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5814,
    y: 11.7207,
    width: 0.325581,
    height: 39.0698,
    transform: "rotate(60 38.5814 11.7207)",
    fill: "currentColor"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 31.5814,
    y: 38.5811,
    width: 0.325581,
    height: 39.0698,
    transform: "rotate(150 31.5814 38.5811)",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheel);
export default __webpack_public_path__ + "static/media/wheel.09edc8904271f815f343d50ee531cd79.svg";
export { ForwardRef as ReactComponent };